import React from 'react';

import FinancingRedirect from 'Modules/fortiva/routes/FinancingRedirect';
import FinancingSuccess from 'Modules/fortiva/routes/FinancingSuccess';

import FinancingDeclined from 'Modules/fortiva/routes/FinancingDeclined';
import Financing from 'Modules/fortiva/routes/Financing';
import CreateApplication from './routes/CreateApplication';
import FinancingRequalify from 'Modules/fortiva/routes/FinancingRequalify';

import { Payment } from 'Modules/cardPayment/routes/Payment';
import MixedSuccess from 'Modules/fortiva/routes/MixedSuccess';
import MixedError from 'Modules/fortiva/routes/MixedError';

export const createFinancingPath = '/financing-fortiva/financing';
export const financingPath = '/financing-fortiva/office/finance';
export const financingSuccessPath = '/financing-fortiva/funded';
export const financingErrorPath = '/financing-fortiva/declined';
export const paymentOptionsPath = '/card-payment/cards';
export const createSecondaryFinancingPath = '/financing-fortiva/financing/secondary';
export const financingRequalifyPath = '/financing-fortiva/requalify';

export const mixedAvailableCreditPath = '/financing-fortiva/mixed/available-credit';
export const mixedDownPaymentCheckoutPath = '/financing-fortiva/mixed/down-payment/checkout';
export const mixedFinancingPath = '/financing-fortiva/mixed/financing';
export const mixedSuccessPath = '/financing-fortiva/mixed/success';
export const mixedErrorPath = '/financing-fortiva/mixed/error';

export const routes = [
  { path: createFinancingPath, element: <FinancingRedirect /> },
  { path: createSecondaryFinancingPath, element: <CreateApplication type="secondary" /> },
  {
    path: financingPath,
    element: (
      <Financing nextRoutes={{ success: financingSuccessPath, error: financingErrorPath }} />
    ),
  },
  {
    path: financingSuccessPath,
    element: <FinancingSuccess />,
  },
  {
    path: financingErrorPath,
    element: <FinancingDeclined />,
  },
  {
    path: financingRequalifyPath,
    element: <FinancingRequalify />,
  },

  {
    path: mixedDownPaymentCheckoutPath,
    element: (
      <Payment
        paymentType="downPayment"
        autoCloseOnlyAfterPayment
        nextRoutes={{
          success: mixedFinancingPath,
          error: mixedErrorPath,
        }}
      />
    ),
  },
  {
    path: mixedFinancingPath,
    element: <Financing nextRoutes={{ success: mixedSuccessPath, error: mixedErrorPath }} />,
  },
  {
    path: mixedSuccessPath,
    element: <MixedSuccess />,
  },
  {
    path: mixedErrorPath,
    element: <MixedError />,
  },
];
